/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface ToggleSubjectDetectionActionArgs {
  /** Toggle action on or off */
  enable: boolean;
  /** Time out for enabling subject detection */
  timeoutS?: number | undefined;
}

export interface ToggleSubjectDetectionResultData {
}

export interface ToggleSubjectDetectionActionStateData {
}

function createBaseToggleSubjectDetectionActionArgs(): ToggleSubjectDetectionActionArgs {
  return { enable: false, timeoutS: undefined };
}

export const ToggleSubjectDetectionActionArgs = {
  encode(message: ToggleSubjectDetectionActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.enable === true) {
      writer.uint32(8).bool(message.enable);
    }
    if (message.timeoutS !== undefined) {
      writer.uint32(21).float(message.timeoutS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ToggleSubjectDetectionActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleSubjectDetectionActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.enable = reader.bool();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.timeoutS = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToggleSubjectDetectionActionArgs {
    return {
      enable: isSet(object.enable) ? globalThis.Boolean(object.enable) : false,
      timeoutS: isSet(object.timeoutS) ? globalThis.Number(object.timeoutS) : undefined,
    };
  },

  toJSON(message: ToggleSubjectDetectionActionArgs): unknown {
    const obj: any = {};
    if (message.enable === true) {
      obj.enable = message.enable;
    }
    if (message.timeoutS !== undefined) {
      obj.timeoutS = message.timeoutS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ToggleSubjectDetectionActionArgs>, I>>(
    base?: I,
  ): ToggleSubjectDetectionActionArgs {
    return ToggleSubjectDetectionActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToggleSubjectDetectionActionArgs>, I>>(
    object: I,
  ): ToggleSubjectDetectionActionArgs {
    const message = createBaseToggleSubjectDetectionActionArgs();
    message.enable = object.enable ?? false;
    message.timeoutS = object.timeoutS ?? undefined;
    return message;
  },
};

function createBaseToggleSubjectDetectionResultData(): ToggleSubjectDetectionResultData {
  return {};
}

export const ToggleSubjectDetectionResultData = {
  encode(_: ToggleSubjectDetectionResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ToggleSubjectDetectionResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleSubjectDetectionResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ToggleSubjectDetectionResultData {
    return {};
  },

  toJSON(_: ToggleSubjectDetectionResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ToggleSubjectDetectionResultData>, I>>(
    base?: I,
  ): ToggleSubjectDetectionResultData {
    return ToggleSubjectDetectionResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToggleSubjectDetectionResultData>, I>>(
    _: I,
  ): ToggleSubjectDetectionResultData {
    const message = createBaseToggleSubjectDetectionResultData();
    return message;
  },
};

function createBaseToggleSubjectDetectionActionStateData(): ToggleSubjectDetectionActionStateData {
  return {};
}

export const ToggleSubjectDetectionActionStateData = {
  encode(_: ToggleSubjectDetectionActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ToggleSubjectDetectionActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleSubjectDetectionActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ToggleSubjectDetectionActionStateData {
    return {};
  },

  toJSON(_: ToggleSubjectDetectionActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ToggleSubjectDetectionActionStateData>, I>>(
    base?: I,
  ): ToggleSubjectDetectionActionStateData {
    return ToggleSubjectDetectionActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToggleSubjectDetectionActionStateData>, I>>(
    _: I,
  ): ToggleSubjectDetectionActionStateData {
    const message = createBaseToggleSubjectDetectionActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
